import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import headEmail from "../assets/icons/email.svg";
import styles from "./Header.module.css";
import fbk from "../assets/icons/facebooklogo.svg";
import logo from "../assets/images/logo3.png";
import touchPhone from "../assets/icons/touchphone.svg";

type headerprops = {
  linksStyle: string;
};

export const Header = ({ linksStyle }: headerprops) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  let headerStyle = styles.links;
  if (linksStyle !== "main") {
    headerStyle = styles.secondaryPages;
  }

  const handleLinkClick = () => {
    setIsMenuOpen(false); // Close menu when a link is clicked
  };

  return (
    // Use a header tag as the main container for semantics and positioning
    <header className={styles.headerContainer}>
      <div className={styles.navHead}>
        <div className={styles.logoHead}>
          {/* Wrap the title in a NavLink to go to the homepage on click */}
          <NavLink to="/" className={styles.titleLink}>
            <h1 className={styles.title}>
              <span className={styles.titleMain}>MASSARI</span>
              <span className={styles.titleSub}>Auto Service</span>
            </h1>
          </NavLink>
        </div>
        <NavLink to="/contact" className={styles.quoteButton}>
          <button className={styles.quote}>
            <p className={styles.buttonName}>BOOK A SERVICE</p>
          </button>
        </NavLink>
      </div>
      {/* Hamburger Button - will be shown/hidden via CSS */}
      <button
        className={styles.hamburgerButton}
        onClick={() => setIsMenuOpen(!isMenuOpen)}
        aria-label="Toggle navigation"
        aria-expanded={isMenuOpen}
      >
        {/* Simple hamburger icon using spans */}
        <span></span>
        <span></span>
        <span></span>
      </button>

      {/* Add 'open' class conditionally */}
      <nav className={`${headerStyle} ${isMenuOpen ? styles.open : ""}`}>
        <NavLink
          to="/"
          className={`${styles.link} ${styles.buttonUnderline}`}
          onClick={handleLinkClick}
        >
          Home
        </NavLink>
        <NavLink
          to="/reviews"
          className={`${styles.link} ${styles.buttonUnderline}`}
          onClick={handleLinkClick}
        >
          Reviews
        </NavLink>
        <NavLink
          to="/contact"
          className={`${styles.link} ${styles.buttonUnderline}`}
          onClick={handleLinkClick}
        >
          Contact
        </NavLink>
        <NavLink
          to="/gallery"
          className={`${styles.link} ${styles.buttonUnderline}`}
          onClick={handleLinkClick}
        >
          Gallery
        </NavLink>
        <NavLink
          to="/about"
          className={`${styles.link} ${styles.buttonUnderline}`}
          onClick={handleLinkClick}
        >
          About
        </NavLink>
      </nav>
    </header>
  );
};
